import {connect} from 'react-redux';
import {size} from 'lodash';
import {get} from 'lodash';
import {createStructuredSelector} from 'reselect';

import {pageSize} from '/constant/data.constant';
import {
  LEVEL,
  PAGE_NUMBER_FIELD_NAME,
  PAGE_SIZE_FIELD_NAME,
  TYPE,
} from '/enum/apiFields.enum';
import {fetch} from '/redux/action/report.action';
import {isClientJourneyLoading} from '/redux/selector/client.selector';
import {paidAsRankDescLastMonth} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {variablesFeatureFlag} from '/redux/selector/remoteConfig.selector';
import {
  hasReportData,
  reportData,
  reportIsLoadingStateValue,
  reportMeta,
} from '/redux/selector/report.selector';
import {calculatePageNumber} from '/util/requestParams.util';
import {withProps} from '/util/selector.util';

import PeopleToContactDataProvider from './PeopleToContactDataProvider';

export default connect(
  createStructuredSelector({
    hasReportData,
    data: reportData,
    reportIsLoading: reportIsLoadingStateValue,
    reportMeta,
    isClientJourneyLoading: isClientJourneyLoading,
    featureFlag: variablesFeatureFlag,
    userId,
    lastPaidRank: withProps({coachId: userId})(paidAsRankDescLastMonth),
  }),
  dispatch => ({
    fetchReport: ({reportName, reportParams, appendData}: any) =>
      // @ts-expect-error TS(2345): Argument of type '{ (dispatch: any, getState: any)... Remove this comment to see the full error message
      dispatch(fetch({reportName, reportParams, appendData})),
  }),
  (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    // @ts-expect-error TS(7030): Not all code paths return a value.
    fetchReport: () => {
      const {reportIsLoading} = stateProps;
      const {
        reportName,
        reportParams: [firstParam = {}, ...restParams] = [],
        screenParams: {type},
      } = ownProps;
      const featureFlag_CC_SR = get(stateProps, 'featureFlag.CC_SR', false);
      if (!reportIsLoading) {
        return dispatchProps.fetchReport({
          reportName,
          reportParams: [
            {
              ...firstParam,
              [TYPE]: type,
              [LEVEL]: featureFlag_CC_SR ? 'genZero' : 'frontLine',
              [PAGE_SIZE_FIELD_NAME]: pageSize,
              [PAGE_NUMBER_FIELD_NAME]: 1,
            },
            ...restParams,
          ],
          appendData: false,
        });
      }
    },
    // @ts-expect-error TS(7030): Not all code paths return a value.
    fetchMoreReport: () => {
      const {reportIsLoading, reportMeta} = stateProps;
      const featureFlag_CC_SR = get(stateProps, 'featureFlag.CC_SR', false);
      const {
        reportName,
        reportParams: [firstParam = {}, ...restParams] = [],
        screenParams: {type},
      } = ownProps;
      const {isEndReached} = reportMeta || {};

      if (!reportIsLoading && !isEndReached) {
        const numberOfRecords = size(stateProps.data);

        const total = reportMeta?.page?.total ?? 0;
        const nextPageNumber = calculatePageNumber({
          numberOfRecords,
          pageSize,
          total,
        });
        if (!nextPageNumber) return;
        return dispatchProps.fetchReport({
          reportName,
          reportParams: [
            {
              ...firstParam,
              [TYPE]: type,
              [LEVEL]: featureFlag_CC_SR ? 'genZero' : 'frontLine',
              [PAGE_SIZE_FIELD_NAME]: pageSize,
              [PAGE_NUMBER_FIELD_NAME]: nextPageNumber,
            },
            ...restParams,
          ],
          appendData: true,
        });
      }
    },
  }),
)(PeopleToContactDataProvider);
